import { render, staticRenderFns } from "./ReadyModalProducts.vue?vue&type=template&id=ecd5a35c&scoped=true&"
import script from "./ReadyModalProducts.vue?vue&type=script&lang=js&"
export * from "./ReadyModalProducts.vue?vue&type=script&lang=js&"
import style0 from "./ReadyModalProducts.vue?vue&type=style&index=0&id=ecd5a35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd5a35c",
  null
  
)

export default component.exports